<cx-spinner class="overlay" *ngIf="isUpdating$ | async"> </cx-spinner>

<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <label class="myaccount-password-header"
    >{{ 'myAccountV2PasswordForm.newPasswordTitle' | cxTranslate }}
  </label>

  <cx-message
    *ngIf="showingAlert"
    [text]="'myAccountV2PasswordForm.reloginIndicator' | cxTranslate"
    [type]="globalMessageType.MSG_TYPE_INFO"
    (closeMessage)="closeDialogConfirmationAlert()"
  >
  </cx-message>

  <label class="myaccount-label-padding">
    <span class="label-content myaccount-password-label">{{
      'myAccountV2PasswordForm.oldPassword.label' | cxTranslate
    }}</span>
    <input
      required="true"
      class="form-control"
      [(ngModel)]="oldPassword"
      type="password"
      name="oldPassword"
      placeholder="{{
        'myAccountV2PasswordForm.oldPassword.placeholder' | cxTranslate
      }}"
      formControlName="oldPassword"
      [attr.aria-label]="
        'myAccountV2PasswordForm.oldPassword.placeholder' | cxTranslate
      "
      [attr.aria-invalid]="
        form.get('oldPassword')?.touched && form.get('oldPassword')?.invalid
      "
      [attr.aria-errormessage]="'oldPasswordError'"
      cxPasswordVisibilitySwitch
    />
    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      id="oldPasswordError"
      [translationParams]="{
        label: 'updatePasswordForm.oldPassword.label' | cxTranslate,
      }"
      [control]="form.get('oldPassword')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('oldPassword')"
    ></cx-form-errors>
  </label>

  <label class="myaccount-label-padding">
    <span class="label-content myaccount-password-label">{{
      'myAccountV2PasswordForm.newPassword.label' | cxTranslate
    }}</span>
    <input
      required="true"
      class="form-control"
      [(ngModel)]="newPassword"
      type="password"
      name="newPassword"
      placeholder="{{
        'myAccountV2PasswordForm.newPassword.placeholder' | cxTranslate
      }}"
      formControlName="newPassword"
      [attr.aria-label]="
        'myAccountV2PasswordForm.newPassword.placeholder' | cxTranslate
      "
      [attr.aria-invalid]="
        form.get('newPassword')?.touched && form.get('newPassword')?.invalid
      "
      [attr.aria-errormessage]="'newPasswordError'"
      cxPasswordVisibilitySwitch
    />

    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      id="newPasswordError"
      [translationParams]="{
        label: 'updatePasswordForm.newPassword.label' | cxTranslate,
      }"
      [control]="form.get('newPassword')"
    ></cx-form-errors>
    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('newPassword')"
    ></cx-form-errors>
  </label>

  <label class="myaccount-label-padding">
    <span class="label-content myaccount-password-label">{{
      'myAccountV2PasswordForm.confirmPassword.label' | cxTranslate
    }}</span>
    <input
      required="true"
      class="form-control"
      [(ngModel)]="newPasswordConfirm"
      type="password"
      name="newPasswordConfirm"
      placeholder="{{
        'myAccountV2PasswordForm.confirmPassword.placeholder' | cxTranslate
      }}"
      formControlName="newPasswordConfirm"
      [attr.aria-label]="
        'myAccountV2PasswordForm.confirmPassword.placeholder' | cxTranslate
      "
      [attr.aria-invalid]="
        form.get('newPasswordConfirm')?.touched &&
        form.get('newPasswordConfirm')?.invalid
      "
      [attr.aria-errormessage]="'newPasswordConfirmError'"
      cxPasswordVisibilitySwitch
    />

    <!-- TODO: (CXSPA-7315) Remove feature toggle in the next major -->
    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      id="newPasswordConfirmError"
      [translationParams]="{
        label: 'updatePasswordForm.confirmPassword.label' | cxTranslate,
      }"
      [control]="form.get('newPasswordConfirm')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('newPasswordConfirm')"
    ></cx-form-errors>
  </label>

  <div class="password-btn-group">
    <button
      class="btn myaccount-password-button myaccount-password-button-cancel"
      (click)="onCancel()"
    >
      {{ 'common.cancel' | cxTranslate }}
    </button>
    <button
      class="btn btn-primary myaccount-password-button"
      [disabled]="form.disabled"
    >
      {{ 'common.save' | cxTranslate }}
    </button>
  </div>
</form>
